/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_IntroInputs */

const en_us2_exercise_personal_goal_intro = /** @type {(inputs: Exercise_Personal_Goal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a weight you want to reach on this exercise. The app tracks how far you are after every workout.`)
};

const pt_br2_exercise_personal_goal_intro = /** @type {(inputs: Exercise_Personal_Goal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um peso que você quer alcançar neste exercício. O app acompanha quanto falta a cada treino.`)
};

const es_419_exercise_personal_goal_intro = /** @type {(inputs: Exercise_Personal_Goal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un peso que quieras alcanzar en este ejercicio. La app sigue cuánto te falta después de cada entrenamiento.`)
};

const pt_pt2_exercise_personal_goal_intro = /** @type {(inputs: Exercise_Personal_Goal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe um peso que queres alcançar neste exercício. A app acompanha quanto falta a cada treino.`)
};

const fr_fr2_exercise_personal_goal_intro = /** @type {(inputs: Exercise_Personal_Goal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis une charge à atteindre sur cet exercice. L'app suit ce qu'il te reste après chaque séance.`)
};

const de_de2_exercise_personal_goal_intro = /** @type {(inputs: Exercise_Personal_Goal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle ein Gewicht, das du bei dieser Übung erreichen willst. Die App zeigt nach jedem Training, wie weit du bist.`)
};

const it_it2_exercise_personal_goal_intro = /** @type {(inputs: Exercise_Personal_Goal_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un peso che vuoi raggiungere in questo esercizio. L'app segue quanto ti manca dopo ogni allenamento.`)
};

/**
* | output |
* | --- |
* | "Pick a weight you want to reach on this exercise. The app tracks how far you are after every workout." |
*
* @param {Exercise_Personal_Goal_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_intro = /** @type {((inputs?: Exercise_Personal_Goal_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_intro(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_intro(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_intro(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_intro(inputs)
	return en_us2_exercise_personal_goal_intro(inputs)
});
export { exercise_personal_goal_intro as "exercise-personal.goal_intro" }